
import { footer, skinCustom } from '../customWhiteLabel'
export default {
  data: () => ({
    formsContacts: {},
    loadingBtn: false,
    colorGradient: '',
    footer,
    skinCustom,
  }),
  head() {
    return {
      title: 'Dúvidas e Suporte',
    }
  },

  methods: {
    sendContact() {
      const validate = this.$refs.form.validate()
      if (validate) {
        return false
      }
    },
  },
}
